import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_QUEUES,
  DELETE_QUEUE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { EnhancedTableStatusCell } from "@vocollege/components";

const Queues: React.FC = () => {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/queues/${id}`);
  };

  const getItemsNumber = (data: any) => {
    return Array.isArray(data.items) ? data.items.length : 0;
  };

  const getFilters = () => {
    return [
      {
        name: "status",
        label: I18n.get.form.labels.status,
        default: ["all"],
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          { label: I18n.get.status.published, value: "1" },
          { label: I18n.get.status.unpublished, value: "0" },
        ],
      },
    ];
  };

  return (
    <Layout>
      <EnhancedTable
        // client={client}
        className="vo-global__top-bottom-space"
        enableSearch
        title={I18n.get.misc.queues}
        operations={{
          category: "queues",
          get: GET_QUEUES,
          delete: DELETE_QUEUE,
        }}
        columns={[
          { title: "ID", field: "id", width: 50 },
          { title: I18n.get.form.labels.title, field: "title", width: 150 },
          {
            title: I18n.get.form.labels.items,
            field: "items",
            render: getItemsNumber,
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data: any) => (
              <EnhancedTableStatusCell data={data.status} />
            ),
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        filters={getFilters()}
      />
    </Layout>
  );
};

export default Queues;
